import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../config";
import { logout } from "../slices/authSlice";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    console.log('[Debug] API Request Headers - Token exists:', !!token);
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api', // ensuring reducerPath matches store setup
  baseQuery: baseQueryWithReauth,
  tagTypes: ["User", "Landing", "Institute", "Job", "UpdateJob", "Blog"], // Added Blog tag for safety
  endpoints: (builder) => ({}),
});
